const SvgPackets = (props) => (
  <svg height="1em" viewBox="0 0 24 14" width="1em" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path
        d="M23.82 6.732L16.705.103A.392.392 0 0 0 16.451 0a.38.38 0 0 0-.256.103l-.86.804a.356.356 0 0 0-.118.262c0 .097.043.194.118.261L21.307 7l-5.972 5.57a.356.356 0 0 0-.118.261c0 .098.043.195.118.262l.86.804a.368.368 0 0 0 .511 0l7.12-6.635A.356.356 0 0 0 23.943 7a.402.402 0 0 0-.125-.268zM2.636 7l5.972-5.57a.356.356 0 0 0 .118-.261.356.356 0 0 0-.118-.262l-.86-.804A.392.392 0 0 0 7.493 0a.38.38 0 0 0-.256.103L.118 6.738A.356.356 0 0 0 0 7c0 .097.044.195.118.262l7.12 6.635a.392.392 0 0 0 .255.103.368.368 0 0 0 .256-.103l.86-.804a.356.356 0 0 0 .118-.262.356.356 0 0 0-.118-.261L2.637 7z"
        fillRule="nonzero"
      />
      <rect
        height={2.4}
        rx={0.5}
        transform="rotate(45 8 7)"
        width={2.4}
        x={6.8}
        y={5.8}
      />
      <rect
        height={2.4}
        rx={0.5}
        transform="rotate(45 16 7)"
        width={2.4}
        x={14.8}
        y={5.8}
      />
      <rect
        height={2.4}
        rx={0.5}
        transform="rotate(45 12 7)"
        width={2.4}
        x={10.8}
        y={5.8}
      />
    </g>
  </svg>
)

export default SvgPackets
